import React, { useState } from 'react';
import { isFunction } from 'lodash';
import classnames from 'classnames';
import { Button } from 'reactstrap';

import { downloadPdfFromHtml } from '../util';

export default function PdfDownloadButton({ label = 'PDF', fileName, html, pdfOptions, children, ...extraProps }) {
  const [isExporting, setIsExporting] = useState(false);

  const onClick = async () => {
    setIsExporting(true);
    try {
      const _html = isFunction(html) ? (await html()) : html;
      await downloadPdfFromHtml(_html, fileName, pdfOptions);
    } finally {
      setIsExporting(false);
    }
  };

  return (
    <Button color="secondary" onClick={onClick} disabled={isExporting} {...extraProps}>
      <span className={classnames('fas mr-1', { 'fa-spin fa-spinner': isExporting, 'fa-file-pdf': !isExporting })} />
      {children || label}
    </Button>
  );
}
